import { SubscribableOrValue, Observable, PureComputed } from "knockout";
import { Quill, StringMap } from 'libraries/quill';

const defaultColor = 'rgb(0, 0, 0)';

interface FormattableConfig {
    quill?: SubscribableOrValue<Quill | undefined>
}

export class Formatter {
    #quill: PureComputed<Quill | undefined>

    isBold: Observable<boolean> = ko.observable(false as boolean)
    isItalic: Observable<boolean> = ko.observable(false as boolean)
    isUnderlined: Observable<boolean> = ko.observable(false as boolean)
    color: Observable<string> = ko.observable(defaultColor)

    update = (focus: boolean = true) => {
        let range = this.#quill()?.getSelection(focus as any),
            formats: StringMap | undefined;

        if (range)
            formats = this.#quill()?.getFormat();

        this.isBold(formats?.bold === true);
        this.isItalic(formats?.italic === true);
        this.isUnderlined(formats?.underline === true);
        this.color(formats?.color ?? defaultColor);
    }

    toggleBold = () => {
        this.toggleFormat('bold');
    }

    toggleItalic = () => {
        this.toggleFormat('italic');
    }

    toggleUnderline = () => {
        this.toggleFormat('underline');
    }

    setColor = (value: string) => {
        this.#quill.invokeNotNull(quill => {
            quill.focus();
            quill.format('color', value === defaultColor ? undefined : value);
        });
    }

    constructor(config: FormattableConfig) {
        this.#quill = ko.observable(config.quill).unwrap();
    }    

    private toggleFormat(type: string) {
        this.#quill.invokeNotNull(quill => {
            let formats = quill.getFormat();

            if (formats[type]) {
                quill.format(type, null);
            } else {
                quill.format(type, true);
            }
        });

        this.update();
    }
}